import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconMudafy from '../build/icon-mudafy'

export const IconMudafy: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconMudafy} />
}

export default IconMudafy
